import { useMedia } from 'react-use';

type Images = {
  mobile: string;
  tablet: string;
  desktop: string;
};

const useResponsiveImage = (images: Images) => {
  const tablet = useMedia('(max-width: 1000px)');
  const mobile = useMedia('(max-width: 480px)');

  if (mobile) {
    return images.mobile;
  } else if (tablet) {
    return images.tablet;
  } else {
    return images.desktop;
  }
};

export { useResponsiveImage };
